const BASE_URL = "process.env.baseUrl";

export const Server = {
  get: async function (
    url: string,
    isAuth?: boolean,
    customOptions?: any,
    customHeader?: any,
  ) {
    let requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        ...customHeader,
      },
    };
    if (customOptions) requestOptions = { ...requestOptions, ...customOptions };

    if (isAuth) {
      const token = localStorage.getItem("_tid");
      requestOptions.headers["Authorization"] = `Bearer ${token}`;
      requestOptions.headers["x-auth-token"] = `Bearer ${token}`;
    }
    const response = await fetch(BASE_URL + url, requestOptions);
    return await response.json();
  },

  getWithToken: async function (
    url: string,
    token: string,
    customOptions?: any,
    customHeader?: any,
  ) {
    let requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        ...customHeader,
      },
    };
    if (customOptions) requestOptions = { ...requestOptions, ...customOptions };

    const response = await fetch(
      BASE_URL + url + `?token=${token}`,
      requestOptions,
    );
    return await response.json();
  },

  post: async function (
    url: string,
    payload: any,
    isAuth: boolean,
    customOptions?: any,
    customHeader?: any,
  ) {
    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        ...customHeader,
      },
      body: JSON.stringify(payload),
    };
    if (customOptions) requestOptions = { ...requestOptions, ...customOptions };
    if (isAuth) {
      const token: string = localStorage.getItem("_tid")!;
      requestOptions.headers["Authorization"] = `Bearer ${atob(token)}`;
      requestOptions.headers["x-auth-token"] = `Bearer ${atob(token)}`;
    }

    const response = await fetch(BASE_URL + url, requestOptions);
    // if (response.status === 200) {
    let jsonResponse = {};
    try {
      jsonResponse = await response.json();
    } catch (e) {
      console.log("unable to parse as json", e);
    }
    return jsonResponse;
    // } else {
    // 	let err = { http_error: response.status, response: response };
    // 	throw err;
    // }
  },

  put: async function (
    url: string,
    id: string,
    payload: any,
    isAuth: boolean,
    customOptions?: any,
    customHeader?: any,
  ) {
    let requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        ...customHeader,
      },
      body: JSON.stringify(payload),
    };
    if (customOptions) requestOptions = { ...requestOptions, ...customOptions };
    if (isAuth) {
      const token: string = localStorage.getItem("_tid")!;
      requestOptions.headers["Authorization"] = `Bearer ${atob(token)}`;
      requestOptions.headers["x-auth-token"] = `Bearer ${atob(token)}`;
    }

    const response = await fetch(BASE_URL + url + "/" + id, requestOptions);
    // if (response.status === 200) {
    let jsonResponse = {};
    try {
      jsonResponse = await response.json();
    } catch (e) {
      console.log("unable to parse as json", e);
    }
    return jsonResponse;
    // } else {
    // 	let err = { http_error: response.status };
    // 	throw err;
    // }
  },

  redirectPost: (url: string, data: any) => {
    const form = document.createElement("form");
    document.body.appendChild(form);
    form.method = "post";
    form.action = url;
    for (const name in data) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = data[name];
      form.appendChild(input);
    }
    form.submit();
  },
};

export default Server;
